module.exports = {"ru":{"notificationTitle":"Уведомление"},"en":{"notificationTitle":"Notification"}}